import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const SAV_DETAIL_TOUR_ID = 'sav-detail';

export const savDetailSteps: StepType[] = [
  {
    selector: '[data-tour="savings-table"]',
    position: 'top',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="right" showPointer={false}>
        Toca tu caja activa para <strong>hacer abonos</strong>, ver tus rendimientos o descargar tu
        estado de cuenta.
      </MascotBubble>
    ),
  },
];
